<!-- <mat-toolbar color="primary" class="app-header">
  <div><a href="#" target="_blank" class="positronx">Demo</a></div>
  <span class="nav-tool-items">
    <a mat-button routerLink="signin" routerLinkActive="active">Signin</a>
    <a mat-button mat-raised-button routerLink="register" routerLinkActive="active">Signup</a>
  </span>
</mat-toolbar> -->

<app-loader></app-loader>
<router-outlet></router-outlet>
<notifier-container></notifier-container>
